import { TranslationExtensionInterface } from '../../../extension/interface/translation.extension.interface';

export class BikeleasingTranslationExtension extends TranslationExtensionInterface {
  moduleName = 'bikeleasing_v2';

  get translations() {
    return {
      contract: {
        accessories: 'Zubehör',
        bikeAcceptanceInfo: 'Durch Klicken auf diesen Knopf bestätige ich, dass das Fahrrad erfolgreich angekommen ist.',
        bikeColor: 'Farbe',
        bikeTakeoverEndOfLeaseInfo:
          'Wenn Du nach Ablauf der regulären Leasingdauer entscheiden möchtest, ob Du das Fahrrad behalten oder zurückgeben möchtest, klicke hier:',
        bikeType: 'Fahrradtyp',
        insurance: {
          packages: {
            comfort: 'Komfort-Versicherung',
            inspection_plus: 'Inspektionspaket',
            premium_plus: 'Verschleiß-Versicherung',
          },
        },
        buttons: {
          accept: 'Akzeptieren',
          reportDamage: 'Fahrradschaden melden',
          allDamageReports: 'Alle Schadensmeldungen',
          bikeTakeoverEndOfLease: 'Entscheidung Leasingende',
          changeInsurancePackage: 'Versicherungspaket ändern',
          download: 'Herunterladen',
          downloadError: 'Herunterladen fehlgeschlagen',
          downloadNotAvailable: 'Für diesen Vertrag ist noch kein PDF verfügbar',
          reject: 'Ablehnen',
          requestEarlyBuyoutOffer: 'Vorzeitiges Ablöseangebot anfordern',
          transmitBikeAcceptance: 'Zustellung bestätigen',
        },
        contractNumber: 'Vertragsnummer {{contractNumber}}',
        damageReportInfo:
          'Im Falle eines Schadens kannst Du Dich auch an Deinen Händler wenden, damit dieser den Schaden ordnungsgemäß melden kann.',
        frameNumber: 'Rahmennummer',
        inspectionInfo:
          'Du hast die Möglichkeit, während der Leasingdauer drei Inspektionen durchführen zu lassen. Zu diesem Zweck erhältst Du hier und per E-Mail 14 Tage vor Beginn des jeweiligen Leistungszeitraums einen Gutscheincode.',
        RRPAccessoriesInclusive: 'Gehaltsumwandlung inkl. Zubehör',
        leasingRateInsuranceInclusive: 'Gehaltsumwandlung inkl. Versicherung',
        lockType: 'Schlosstyp',
        moreInformation: 'Weitere Informationen',
        requestEarlyBuyoutOfferInfo:
          'Wenn Du daran interessiert bist, das Fahrrad vor Ablauf der regulären Leasingdauer zu kaufen, klicke hier:',
        section: {
          inspection: 'Inspektion',
        },
        status: {
          label: 'Status',
        },
        toTheCodes: 'Zu den Codes',
        trailer: 'Anhänger',
      },
      infoPage: {
        informNow: 'Jetzt informieren',
        resources: {
          title: 'Hilfreiche Ressourcen',
          titleAT: 'Mehr zu Bikeleasing',
          faq: 'FAQ',
          howToDienstrad: 'How to Dienstrad',
          leasableAccessories: 'Leasingfähiges Zubehör',
          insuranceManual: 'Versicherungshandbuch',
        },
      },
      dealers: {
        noData: 'Bei der Suche nach den Händlern gab es ein Problem. Versuche es bitte später erneut.',
      },
    };
  }
}
